export default {"src":"https://fishbrain.com/_next/static/media/amberjack.d2324b77.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};